<template>
  <div class="card-aside-wrap">
    <div class="card-content">
      <slot name="contentWrapper"></slot>
    </div>
    <div class="card-aside user-aside toggle-slide toggle-slide-left toggle-break-lg"
         :class="asideClasses"
         data-toggle-screen="lg" data-toggle-overlay="true">
      <div class="card-inner-group" data-simplebar>
        <slot name="aside"></slot>
      </div>
    </div>
    <div class="toggle-overlay" v-if="asideActive" v-on:click="toggleAside"></div>
  </div>
</template>

<script>
import {computed} from "vue";

export default {
  props: {
    sidebarPosition: {
      type: String,
      default: 'left',
    },
    asideActive: Boolean,
  },
  emits: ['toggleSidebar'],
  setup( props, {emit} ){

    let asideClasses = computed(()=>{
      let classes = [`card-aside-${props.sidebarPosition}`]
      if(props.asideActive){
        classes.push('content-active')
      }
      return classes
    })

    const toggleAside = () => emit('toggleSidebar')

    return {
      asideClasses,
      toggleAside,
    }
  },
}
</script>
